import axios, { AxiosRequestConfig } from "axios";
import { BASE_URL, LEADERBOARD_URL } from "../util/constants";
import Medal from "../interfaces/medal";
import PagedResult from "../interfaces/pagedResult";
import Leaderboard from "../interfaces/leaderboard";

const useApiLeaderboard = () => {
    const axiosInstance = axios.create({
        baseURL: BASE_URL,
    });

    const listCategories = () => {
        return axiosInstance
            .get<Medal[]>(`${LEADERBOARD_URL}/types`)
            .then((res) => res.data)
            .catch((err) => {
                handleError(err);
                throw err;
            });
    };

    const getPagedLeaderboard = (config: AxiosRequestConfig) => {
        return axiosInstance
            .get<PagedResult<Leaderboard>>(`${LEADERBOARD_URL}/paged`, config)
            .then((res) => res.data)
            .catch((err) => {
                handleError(err);
                throw err;
            });
    };

    const handleError = (err: any) => {
        console.log("Error occurred: ", err);

        if(err.response) {
            console.log("Response: ", err.response.data);
            console.log("Status: ", err.response.status);
        } else if(err.request && err.config) {
            console.log("URL: ", err.config.baseURL);
            console.log("Method: ", err.config.method);
            console.log("URL requested: ", err.config.url);
        } else {
            console.log("Error message: ", err.message);
        }
    };

    return { listCategories, getPagedLeaderboard };
}

export default useApiLeaderboard;